import * as React from 'react';
import { styleSingleton } from 'react-style-singleton';
import { focusHiddenMarker } from './medium';
var Style = styleSingleton();
var styles = "\n [" + focusHiddenMarker + "] {\n   pointer-events: none !important;\n }\n";
export var InteractivityDisabler = function () { return React.createElement(Style, { styles: styles }); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-focus-on/dist/es2015/InteractivityDisabler.js
// module id = 598
// module chunks = 0